// extracted by mini-css-extract-plugin
export var active = "DesktopLayout-module--active--ae928";
export var cardsTrack = "DesktopLayout-module--cardsTrack--dbe14";
export var cardsWrapper = "DesktopLayout-module--cardsWrapper--9e475";
export var defaultWidth = "DesktopLayout-module--defaultWidth--6566b";
export var fadeInAnimation = "DesktopLayout-module--fadeInAnimation--b9739";
export var hidden = "DesktopLayout-module--hidden--32e6f";
export var mediumWidth = "DesktopLayout-module--mediumWidth--6d09c";
export var navArrow = "DesktopLayout-module--navArrow--82252";
export var next = "DesktopLayout-module--next--44dad";
export var pagination = "DesktopLayout-module--pagination--d4cec";
export var paginationButton = "DesktopLayout-module--paginationButton--40ac0";
export var prev = "DesktopLayout-module--prev--27d52";
export var sliderWrapper = "DesktopLayout-module--sliderWrapper--cbde8";
export var smallWidth = "DesktopLayout-module--smallWidth--78cdd";
export var withTransition = "DesktopLayout-module--withTransition--1e6a1";